import {useMediaQuery} from "react-responsive";

function useIsMobile() {
    const isMobile = useMediaQuery({query: '(max-aspect-ratio: 1/1)'})
    return isMobile
}

export default useIsMobile;
